import { useEffect, useState } from 'react'
import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { Object3D } from 'three'

import s from './Configurator.module.scss'
import { ConfiguratorButton } from '../ConfiguratorButton/ConfiguratorButton'
import { DiamondCut } from '../../../../../trillion-common/src/objects/diamond-cut.object'
import { MaterialColor } from '../../../../../trillion-common/src/objects/material-color.object'
import { StoneSize } from '../../../../../trillion-common/src/objects/stone-size.object'

interface ConfiguratorProps {
  model: Object3D | undefined
  items: Array<MaterialColor | DiamondCut | StoneSize | number>
  currentItem: MaterialColor | DiamondCut | StoneSize | number | undefined
  title: string
  onChange: (model: Object3D, currentIndex: number, prevIndex: number) => void
}

export const Configurator = ({ model, items, currentItem, title, onChange }: ConfiguratorProps) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [prevIndex, setPrevIndex] = useState(-1)

  const handleNavigationLeft = () => {
    setPrevIndex(currentIndex)
    setCurrentIndex(currentIndex === 0 ? items.length - 1 : currentIndex - 1)
  }

  const handleNavigationRight = () => {
    setPrevIndex(currentIndex)
    setCurrentIndex(currentIndex === items.length - 1 ? 0 : currentIndex + 1)
  }

  useEffect(() => {
    if (!model || !items) return

    onChange(model, currentIndex, prevIndex)
  }, [currentIndex])
  const description = typeof currentItem === 'number' ? currentItem : currentItem?.description
  const isLessThanOne = items.length <= 1

  if (!currentItem) return null

  return (
    <AnimatePresence>
      <motion.div
        initial={{ bottom: -60, left: '50%' }}
        exit={{ bottom: -60, left: '50%' }}
        transition={{ duration: 0.6 }}
        className={s.Configurator}
      >
        <div className={s.configurator_wrapper}>
          <ConfiguratorButton
            disabled={isLessThanOne}
            direction={'left'}
            onSelect={handleNavigationLeft}
          />
          <div className={s.configurator_label}>
            <div className={classNames(s.configurator_label, s.top)}>{title}</div>
            <AnimatePresence mode="wait">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}
                className={classNames(s.configurator_label, s.bottom)}
                key={description}
              >
                {description}
              </motion.div>
            </AnimatePresence>
          </div>
          <ConfiguratorButton
            disabled={isLessThanOne}
            direction={'right'}
            onSelect={handleNavigationRight}
          />
        </div>
      </motion.div>
    </AnimatePresence>
  )
}
